/**
 * @generated SignedSource<<aaeb11ca495d9abf69d751ba0cb84747>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type noteTemplateGqlStarNoteTemplateMutation$variables = {
  id: string;
};
export type noteTemplateGqlStarNoteTemplateMutation$data = {
  readonly starNoteTemplate: {
    readonly template: {
      readonly id: string;
      readonly starred: boolean;
    };
  } | null;
};
export type noteTemplateGqlStarNoteTemplateMutation = {
  response: noteTemplateGqlStarNoteTemplateMutation$data;
  variables: noteTemplateGqlStarNoteTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "templateId",
        "variableName": "id"
      }
    ],
    "concreteType": "StarNoteTemplate",
    "kind": "LinkedField",
    "name": "starNoteTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteTemplateNode",
        "kind": "LinkedField",
        "name": "template",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "starred",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "noteTemplateGqlStarNoteTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "noteTemplateGqlStarNoteTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9bb833b429a41d0adda2a0b934d30a27",
    "id": null,
    "metadata": {},
    "name": "noteTemplateGqlStarNoteTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation noteTemplateGqlStarNoteTemplateMutation(\n  $id: ID!\n) {\n  starNoteTemplate(templateId: $id) {\n    template {\n      id\n      starred\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cad34a41f1b183ee09110cc0a0bee6f5";

export default node;
